import { useState } from 'react';
import { TextField, InputAdornment, IconButton } from 'components/mui';
import { VisibilityIcon, VisibilityOffIcon } from 'components/icons';
import { bool, func, string } from 'prop-types';

const InputPassword = (props) => {
	const [showPassword, setShowPassword] = useState(false);

	return (
		<TextField
			id={props.id}
			label={props.label}
			value={props.value}
			error={props.error}
			helperText={props.helperText}
			onChange={props.onChange}
			required
			type={showPassword ? 'text' : 'password'}
			size={props.size}
			variant={props.variant}
			InputLabelProps={{ shrink: true }}
			InputProps={{
				endAdornment: (
					<InputAdornment position="end">
						<IconButton onClick={() => setShowPassword(!showPassword)}>
							{showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
						</IconButton>
					</InputAdornment>
				),
			}}
		/>
	);
};

InputPassword.propTypes = {
	id: string,
	required: bool,
	label: string,
	value: string,
	variant: string,
	size: string,
	onChange: func,
	error: bool,
	helperText: string,
};

export default InputPassword;
